import { useEffect, useRef, useState } from "react";
import { api, brl, formatApiError } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { Input } from "@/components/ui/input";
import { laborPrice } from "@/components/Labor";
import { toast } from "sonner";
import { BookmarkPlus } from "lucide-react";

// Campo de descrição com sugestões do cadastro de serviços; escolher preenche, mas tudo continua editável.
export function ServiceSuggestInput({ value, onChange, onPick, testid, className, placeholder }) {
  const { user } = useAuth();
  const [list, setList] = useState([]);
  const [open, setOpen] = useState(false);
  const t = useRef(null);
  useEffect(() => {
    clearTimeout(t.current);
    const q = (value || "").trim();
    if (!open || q.length < 2) { setList([]); return undefined; }
    t.current = setTimeout(() => { api.get("/labor", { params: { q } }).then(({ data }) => setList(data.slice(0, 8))).catch(() => setList([])); }, 250);
    return () => clearTimeout(t.current);
  }, [value, open]);
  const pick = (s) => {
    onPick({ code: s.code || null, description: s.name, unit_price: laborPrice(s, user?.shop?.hourly_rate), cost: s.cost ?? null, hours: s.hours ?? null });
    setOpen(false);
  };
  return (
    <div className="relative">
      <Input data-testid={testid} value={value} onChange={(e) => { onChange(e.target.value); setOpen(true); }} onFocus={() => setOpen(true)}
        onBlur={() => setTimeout(() => setOpen(false), 150)} className={className} placeholder={placeholder} autoComplete="off" />
      {open && list.length > 0 && (
        <div data-testid={`${testid}-suggestions`} className="absolute z-30 left-0 right-0 mt-1 max-h-60 overflow-y-auto rounded-xl border border-zinc-800 bg-zinc-950 shadow-xl">
          {list.map((s) => (
            <button key={s.id} type="button" data-testid={`${testid}-sugg-${s.id}`} onMouseDown={(e) => { e.preventDefault(); pick(s); }}
              className="w-full text-left px-3 py-2 hover:bg-zinc-900 flex justify-between gap-2 text-sm">
              <span className="text-zinc-100 min-w-0 truncate">{s.code ? <span className="text-zinc-500 text-xs font-mono mr-1">{s.code}</span> : null}{s.name}</span>
              <span className="text-zinc-400 whitespace-nowrap">{brl(laborPrice(s, user?.shop?.hourly_rate))}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

export function SaveAsServiceButton({ item, testid }) {
  const [busy, setBusy] = useState(false);
  const save = async () => {
    if (!(item.description || "").trim()) { toast.error("Preencha a descrição antes"); return; }
    setBusy(true);
    try {
      const { data } = await api.post("/labor", { name: item.description.trim(), code: item.code || null, price: Number(item.unit_price) || 0,
        cost: item.cost === "" || item.cost == null ? null : Number(item.cost) });
      toast.success(`Serviço cadastrado (${data.code})`);
    } catch (e) { toast.error(formatApiError(e)); } finally { setBusy(false); }
  };
  return (
    <button type="button" data-testid={testid} onClick={save} disabled={busy} title="Cadastrar este item em Configurações › Serviços"
      className="inline-flex items-center gap-1 text-[11px] text-sky-300 hover:text-sky-200 disabled:opacity-50"><BookmarkPlus className="h-3.5 w-3.5" /> Salvar como serviço</button>
  );
}
